// extracted by mini-css-extract-plugin
module.exports = {"varFontSize100":"var(--tkww-union-typography-scale-100-font-size, 0.75rem)","sectionHeader":"sectionHeader--b86ae"};